// Pathfinder Companion app store links surfaced on the success screen.
export const APP_STORE_URL = 'https://apps.apple.com/app/id1523679587';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.pfsbc.pathfinder.aspen';
